export const ANNOUNCEMENT_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
}
